import { _axios } from "@/plugins/axios";
// const cancelReq = cancelRequest;
const login = async req => await _axios.post("/user/login", req);
const logout = async req => await _axios.post("/user/logout", {});

export { login, logout };
